module.exports = __webpack_public_path__ + "media/back.6cd657f1.mp4";